<template>
	<div class="qa-question">
		<span class="cntitle">{{mainWord3.chTitle}}</span>
		<div class="main-question">
			<div class="q-a-word" v-for="(item, index) in QAword">
				<span :class="'t' + index">{{item}}</span>
			</div>
			<div class="q-a-mainword" v-for="(item, index) in QAword1">
				<span :class="num" v-for="(qAnda, num) in item">{{qAnda}}</span>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">

// const api = 'http://localhost:8080/static/content/qaword.json'

export default {
	data() {
		return {
		}
	},
	created() {
		// this._getqaword()
	},
	methods: {
		// _getqaword() {
		// 	this.$axios.get(api).then((res) => {
		// 		this.QAword = res.data
		// 	})
		// }
	},
	computed: {
		mainWord3() {
			return this.$t('mainWord3')
		},
		QAword() {
			return this.$t('title')
		},
		QAword1() {
			return this.$t('qaword')
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.main-question
		padding-top: 50px
		border-top: 1px solid $color-theme
		.q-a-word
			display: block
			text-align: center
			width: 90%
			.t0
				font-size: $font-web-medium
				@media screen and (max-width:550px)
					font-size: $font-web-small
			.t1
				font-size: $font-web-small
				color: $color-text-g
				line-height: $font-web-small
				@media screen and (max-width:550px)
					font-size: $font-web-small-s
		.q-a-word:nth-child(2)
			margin-bottom: 30px
		.q-a-mainword
			width: 90%
			display: block
			margin-bottom: 20px
			padding-bottom: 15px
			border-bottom: 1px solid $color-text-m
			@media screen and (max-width:550px)
				margin-bottom: 15px
			span
				display: block
				color: $color-text-g
				font-size: $font-web-small
				line-height: $font-web-medium
				padding-bottom: 2px
				@media screen and (max-width:550px)
					font-size: $font-web-small-s
					line-height: $font-web-medium-s
					padding-bottom: 1px
		.q-a-mainword:nth-child(8)
			border-bottom: none

</style>



// WEBPACK FOOTER //
// src/components/tab-item/qa-question.vue